import React from 'react';
import { RefreshCw, WifiOff, ServerCrash, ShieldAlert } from 'lucide-react';
import { Loader } from '../../icons/Loader';
import { mapServiceError } from '../../utils/serviceErrors';

const KIND_ICONS = {
  network: WifiOff,
  unavailable: ServerCrash,
  permission: ShieldAlert,
  auth: ShieldAlert,
  quota: ServerCrash,
  unknown: ServerCrash,
};

/**
 * Wraps content with consistent loading and error states.
 * Empty states are left to the parent (often filter-specific).
 */
export function DataFetchState({
  loading = false,
  error = null,
  onRetry,
  loadingLabel = 'Loading',
  loadingVariant = 'dog',
  errorTitle,
  errorMessage,
  children,
  className = '',
  compact = false,
}) {
  if (loading) {
    return (
      <div
        className={`flex items-center justify-center ${compact ? 'py-16' : 'py-24'} ${className}`.trim()}
        aria-busy="true"
      >
        <Loader variant={loadingVariant} label={loadingLabel} />
      </div>
    );
  }

  if (error) {
    const mapped = mapServiceError(error);
    const Icon = KIND_ICONS[mapped.kind] || ServerCrash;
    const title = errorTitle || mapped.title;
    const message = errorMessage || mapped.message;

    return (
      <div
        className={`pf-service-error ${compact ? 'pf-service-error--compact' : ''} ${className}`.trim()}
        role="alert"
      >
        <div className="pf-service-error__icon" aria-hidden="true">
          <Icon className="w-8 h-8" />
        </div>
        <h3 className="pf-service-error__title">{title}</h3>
        <p className="pf-service-error__message">{message}</p>
        {onRetry ? (
          <button type="button" onClick={onRetry} className="pf-btn-primary inline-flex items-center gap-2 mt-2">
            <RefreshCw className="w-4 h-4" aria-hidden="true" />
            Try again
          </button>
        ) : null}
        <p className="pf-service-error__support text-sm mt-4">
          Still stuck?{' '}
          <a href="mailto:support@PetsFostering.com" className="text-[var(--pf-accent)] font-medium hover:underline">
            Contact support
          </a>
        </p>
      </div>
    );
  }

  return children;
}

export default DataFetchState;
